var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard4Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 27,
    fill: "#A8A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI QUIZ BOOSTER",
    clipPath: "url(#clip0_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    transform: "translate(-1036 -2525)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64",
    opacity: 0.2,
    filter: "url(#filter0_f_13_7334)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -101.5,
    cy: 27.5,
    rx: 374.5,
    ry: 395.5,
    transform: "rotate(90 -101.5 27.5)",
    fill: "#FFBB00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    opacity: 0.9975,
    filter: "url(#filter1_d_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.8125,
    y: -39.23,
    width: 546.91,
    height: 265.77,
    rx: 19,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "span.lqd-bg-layer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.8125,
    y: -39.23,
    width: 546.91,
    height: 265.76,
    rx: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip1_13_7334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0963 26.7798L10.713 26.6097C10.2864 26.4223 0.324219 21.921 0.324219 13.77V6.70237C0.324599 6.02222 0.53947 5.35953 0.938232 4.80867C1.33699 4.25781 1.89932 3.84687 2.54512 3.63437L11.1526 0.779785L19.7602 3.63437C20.406 3.84687 20.9682 4.25781 21.367 4.80867C21.7658 5.35953 21.9807 6.02222 21.9811 6.70237V13.77C21.9811 23.0618 11.9236 26.5046 11.4948 26.6476L11.0963 26.7798ZM11.1526 3.05154L3.23056 5.6797C3.01502 5.75014 2.82728 5.887 2.69424 6.0707C2.5612 6.25441 2.48967 6.47552 2.4899 6.70237V13.77C2.4899 19.7218 9.4634 23.5828 11.2036 24.4528C12.9404 23.754 19.8153 20.5549 19.8153 13.77V6.70237C19.8155 6.47552 19.7441 6.25441 19.611 6.0707C19.478 5.887 19.2902 5.75014 19.0747 5.6797L11.1526 3.05154Z",
    fill: "url(#paint0_linear_13_7334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1904 16.5239H10.1546C9.88055 16.5197 9.61016 16.4599 9.35984 16.3482C9.10951 16.2365 8.88442 16.0751 8.6982 15.8739L6.20117 13.2739L7.76154 11.7767L10.1915 14.3117L15.8016 8.69897L17.3328 10.2308L11.6359 15.9302C11.4462 16.1199 11.2207 16.27 10.9726 16.3719C10.7244 16.4738 10.4585 16.5255 10.1904 16.5239Z",
    fill: "url(#paint1_linear_13_7334)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_7334",
    x: -901.1,
    y: -751.1,
    width: 1599.2,
    height: 1557.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.05,
    result: "effect1_foregroundBlur_13_7334"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_7334",
    x: -103.812,
    y: -79.23,
    width: 634.91,
    height: 353.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.729412 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_7334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_7334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7334",
    x1: 0.324219,
    y1: 0.779785,
    x2: 25.8959,
    y2: 22.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0336FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_7334",
    x1: 6.20117,
    y1: 8.69897,
    x2: 13.564,
    y2: 19.1732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0336FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C5EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    fill: "white",
    transform: "translate(-1036 -2525)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.99,
    height: 26,
    fill: "white",
    transform: "translate(0.158203 0.77002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4Img);
export default __webpack_public_path__ + "static/media/card4Img.70bbf66d3b926ac80523e46a74c6bcd8.svg";
export { ForwardRef as ReactComponent };